import React from 'react'
import {TramitesContextProvider} from '../contexto/TramitesContext'
import {Listado} from '../componentes/Listado'
import Main from '../../../componentes/Main'
import {useParams} from 'react-router-dom'


export const TramitesNew = ({version})=>{
    let parameters = useParams()
    
    return <TramitesContextProvider>
                <Main >
                     <Listado version={parameters.version || '1.0'}/>
                </Main> 
            </TramitesContextProvider> 
}

